// combatpro/panels/monsters/MonsterFilters.js
//
// Combat PRO - MonsterFilters (decomposition of MonsterPanel.js).
//
// Static markup only, moved verbatim from MonsterPanel.js (the advancedFilters
// block: Challenge Rating min/max, Creature Type, Size, and Clear All Filters).
// IDs, class names, inline styles, option values, text, order, and wrapper
// hierarchy are preserved exactly. All controls are inert (no handlers), exactly
// as in the source. No state, hooks, logic, calculations, or filtering. Imports
// only React. Do not edit battletracker.html.

import React from 'react';

function MonsterFilters() {
  return (
    <div id="advancedFilters" className="vi-filters">
      <div className="vi-filters-grid">
        <div>
          <label className="vi-filter-label">Challenge Rating (CR)</label>
          <div className="vi-cr-row">
            <select id="crMin" defaultValue="0">
              <option value="0">Min: 0</option><option value="0.125">Min: 1/8</option>
              <option value="0.25">Min: 1/4</option><option value="0.5">Min: 1/2</option>
              <option value="1">Min: 1</option><option value="2">Min: 2</option>
              <option value="3">Min: 3</option><option value="4">Min: 4</option>
              <option value="5">Min: 5</option><option value="6">Min: 6</option>
              <option value="7">Min: 7</option><option value="8">Min: 8</option>
              <option value="9">Min: 9</option><option value="10">Min: 10</option>
              <option value="15">Min: 15</option><option value="20">Min: 20</option>
              <option value="25">Min: 25</option><option value="30">Min: 30</option>
            </select>
            <span className="vi-cr-sep">to</span>
            <select id="crMax" defaultValue="30">
              <option value="30">Max: 30</option><option value="0.125">Max: 1/8</option>
              <option value="0.25">Max: 1/4</option><option value="0.5">Max: 1/2</option>
              <option value="1">Max: 1</option><option value="2">Max: 2</option>
              <option value="3">Max: 3</option><option value="4">Max: 4</option>
              <option value="5">Max: 5</option><option value="6">Max: 6</option>
              <option value="7">Max: 7</option><option value="8">Max: 8</option>
              <option value="9">Max: 9</option><option value="10">Max: 10</option>
              <option value="15">Max: 15</option><option value="20">Max: 20</option>
              <option value="25">Max: 25</option><option value="30">Max: 30</option>
            </select>
          </div>
        </div>
        <div>
          <label className="vi-filter-label">Creature Type</label>
          <select id="typeFilter" className="vi-filter-select" defaultValue="All">
            <option value="All">All Types</option><option value="Aberration">Aberration</option>
            <option value="Beast">Beast</option><option value="Celestial">Celestial</option>
            <option value="Construct">Construct</option><option value="Dragon">Dragon</option>
            <option value="Elemental">Elemental</option><option value="Fey">Fey</option>
            <option value="Fiend">Fiend</option><option value="Giant">Giant</option>
            <option value="Humanoid">Humanoid</option><option value="Monstrosity">Monstrosity</option>
            <option value="Ooze">Ooze</option><option value="Plant">Plant</option>
            <option value="Undead">Undead</option>
          </select>
        </div>
        <div style={{ gridColumn: '1 / -1', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', alignItems: 'end' }}>
          <div>
            <label className="vi-filter-label">Size</label>
            <select id="sizeFilter" className="vi-filter-select" defaultValue="All">
              <option value="All">All Sizes</option><option value="Tiny">Tiny</option>
              <option value="Small">Small</option><option value="Medium">Medium</option>
              <option value="Large">Large</option><option value="Huge">Huge</option>
              <option value="Gargantuan">Gargantuan</option>
            </select>
          </div>
          <div>
            <button className="vi-btn vi-btn-secondary vi-btn-full" style={{ height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>🔄 Clear All Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MonsterFilters;
